// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const jmbg: CountryValidator<"BA", ParsedPersonId> =
  createValidator("ba.jmbg", 16);

export default jmbg;
export const compact = jmbg.compact;
export const format = jmbg.format;
export const validate = jmbg.validate;
export const generate = (): string =>
  jmbg.generate?.() ??
  (() => {
    throw new Error(
      "Validator ba.jmbg cannot generate values",
    );
  })();
export const parse = jmbg.parse;
